import React, { useMemo, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Tags from '../../../common/Tags';
import { AppliedCouponTag } from '../../../common/Tags/defaultTags';

import { formatURL, formatPrice, cleanDate, getProductDiscount } from '../../../../utils';
import { maxValueParcel } from '../../../../utils/plan';
import {
  sendToRDStation,
  getProductPurchaseUrl,
  selectPlanAndRedirect,
  insertTagPurchaseUrl,
} from '../../../../utils/plan';

import { fetchUpsellPlan } from '../../../../apiCalls';
import { openModalUpsell, setUpsellPlans, setUpsellSourceTags } from '../../../../actions/searchActions';

import styles from './styles.module.css';


// TODO: add the code of the tag of the highlight
const codeTagHighlight = '71';

const ShowUpPlan = ({
  plan,
  isSelected,
  basePath,
  match,
  userDetails,
  providerImgPath,
  openModalQuotationDateWarning,
  addComparisonPlan,
  removeComparisonPlan,
  paymentMethods,
  coupon,
  variant,
  openModalUpsell,
  setUpsellPlans,
  setUpsellSourceTags,
}) => {
  const upsellPlanRef = useRef(null);
  const upsellFetchedRef = useRef(false);

  useEffect(() => {
    if (plan.upsell_product_id == null || upsellFetchedRef.current) return;

    upsellFetchedRef.current = true;
    const { destination, begin_date, end_date } = match.params;

    fetchUpsellPlan({
      begin_date,
      end_date,
      destination,
      product_code: plan.upsell_product_id,
    }).then((data) => {
      upsellPlanRef.current = data;
    });
  }, [plan.upsell_product_id, match.params]);

  const pixDiscountMultiplier = useMemo(() => {
    if (paymentMethods && paymentMethods.length > 0) {
      const pixPayment = paymentMethods.find((method) => method.slug === 'pix');
      if (pixPayment && pixPayment.discount > 0) {
        return (100 - pixPayment.discount) / 100;
      }
    }
    return 0.95;
  }, [paymentMethods]);

  const selectPlan = async () => {
    sendToRDStation();

    const tags = [codeTagHighlight];

    const productPurchaseUrl = insertTagPurchaseUrl(getProductPurchaseUrl(match, plan.code), tags.join(','));

    if (plan.upsell_product_id != null) {
      let upsellPlanData = upsellPlanRef.current;

      if (!upsellPlanData) {
        const { destination, begin_date, end_date } = match.params;
        upsellPlanData = await fetchUpsellPlan({
          begin_date,
          end_date,
          destination,
          product_code: plan.upsell_product_id,
        });
      }

      if (upsellPlanData && upsellPlanData.code) {
        const normalizedPlan = { ...plan, adult: plan.adult || (plan.price && plan.price.adult) };
        setUpsellSourceTags([codeTagHighlight]);
        setUpsellPlans([normalizedPlan, upsellPlanData]);
        return openModalUpsell();
      }
    }

    selectPlanAndRedirect(productPurchaseUrl);
  };

  const tag = null;

  const productUrl = formatURL(
    match.params,
    `${basePath}/${plan.code}/${match.params.destination}/${cleanDate(match.params.begin_date)}/${cleanDate(
      match.params.end_date
    )}/`
  );

  const benefitsBaggage = plan.benefits.filter((benefit) => benefit.code === '42' || benefit.code === 42)[0];
  const benefitsHospital = plan.benefits.filter((benefit) => benefit.code === '51' || benefit.code === 51)[0];

  const priceWithCouponDiscount = useMemo(
    () => getProductDiscount(plan.price.adult.price, plan.code, coupon),
    [coupon, plan.code, plan.price.adult.price]
  );
  const price = priceWithCouponDiscount || plan.price.adult.price;
  const parcels = useMemo(() => maxValueParcel(price) || 1, [price]);

  const isV2 = (variant || '').toString().toUpperCase() === 'V2';

  const formatBenefitsCoverage = (benefit) => {
    if (!isV2) return benefit;

    const match = benefit.match(/[\d.,]+/);
    return `$ ` + match[0];
  };

  return (
    <div
      className={
        isV2
          ? `${styles.showUpPlanV2} ${isSelected ? styles.selected : ''} ${plan.priority !== 0 ? styles.secondary : styles.primary
          }`
          : `show-up-plan${isSelected ? ' selecionado' : ''}${plan.priority !== 0 ? ' secondary' : ' primary'}`
      }
      data-variant={isV2 ? 'V2' : undefined}
    >
      <div className={`triangle-topleft${isSelected ? '' : ' hide'}`}>
        <img className="selecionado-ico" src="/assets/images/selecionado-ico.svg" alt="Selecionado" />
      </div>


      <Tags tag={tag} isMobile={false} />
      <Tags tag={tag} isMobile={true} />

      {isV2 && priceWithCouponDiscount > 0 && (
        <React.Fragment>
          <Tags tag={AppliedCouponTag} isMobile customClassName={isV2 ? '' : 'search-applied-coupon-v1'} />
          <Tags tag={AppliedCouponTag} isMobile={false} customClassName={isV2 ? '' : 'search-applied-coupon-v1'} />
        </React.Fragment>
      )}

      <div className={isV2 ? styles.headerV2 : 'header'}>
        <div className={isV2 ? styles.image : 'image'}>
          <img onClick={selectPlan} src={providerImgPath} alt="" />
        </div>
        <div className={isV2 ? styles.planName : ''}>
          <span onClick={selectPlan}>{plan.name}</span>
        </div>
      </div>

      {!isV2 ? (
        <div className="box-footer-plan">
          {priceWithCouponDiscount ? (
            <React.Fragment>
              <React.Fragment>
                <Tags tag={AppliedCouponTag} isMobile customClassName="search-applied-coupon" />
                <Tags tag={AppliedCouponTag} isMobile={false} customClassName="search-applied-coupon" />
              </React.Fragment>

              <span className="old-price">R$ {formatPrice(plan.price.adult.price)}</span>
            </React.Fragment>
          ) : (
            <div />
          )}

          <div className="price">
            <div className="price-pix">
              <span>R$ {formatPrice(price * pixDiscountMultiplier)}</span>
              <span className="price-person">/ Por pessoa no PIX</span>
            </div>
            <span className="price-atually">
              ou R$ {formatPrice(price)} em até {parcels}x sem juros no cartão
            </span>
          </div>
        </div>
      ) : (
        <div className={styles.price}>
          <div children={styles.flexColumn}>
            {priceWithCouponDiscount > 0 && <span className={styles.oldPrice}>R$ {formatPrice(plan.price.adult.price)}</span>}
            <div className={styles.pricePix}>

              <span>R$ {formatPrice(price * pixDiscountMultiplier)}</span>
              <span className={styles.pricePerson}>/ preço por pessoa</span>
            </div>
          </div>
          <span className={styles.priceAtually}>
            ou R$ {formatPrice(price)} até {parcels}x s/juros no cartão
          </span>
        </div>
      )}

      <div className={isV2 ? styles.benefits : 'benefits'}>
        <div className={isV2 ? styles.planInfo : 'plan-info'}>
          <span>Despesa Médica Hospitalar</span>
          <span className={isV2 ? styles.planBenefitValue : 'plan-info-benefit'}>
            {formatBenefitsCoverage(benefitsHospital.coverage)}
          </span>
        </div>

        <div className={isV2 ? styles.planInfo : 'plan-info'}>
          <span>Seguro bagagem</span>
          <span className={isV2 ? styles.planBenefitValue : 'plan-info-benefit'}>
            {formatBenefitsCoverage(benefitsBaggage.coverage)}
          </span>
        </div>

        <div className={isV2 ? styles.roofLink : 'link'}>
          <Link to={productUrl} className="url-roof">
            Ver a cobertura completa
          </Link>
        </div>
      </div>

      <a className={isV2 ? styles.selectButton : 'select-button'} onClick={selectPlan}>
        Selecionar seguro
      </a>

      <label htmlFor={`compare-button${plan.code}`} className={isV2 ? styles.compareButton : 'compare-button'}>
        <input
          name=""
          type="checkbox"
          defaultChecked={isSelected}
          id={`compare-button${plan.code}`}
          onClick={() => {
            if (isSelected) {
              removeComparisonPlan(plan.code);
            } else {
              addComparisonPlan({ ...plan });
            }
          }}
        />
        Comparar Plano
      </label>
    </div>
  );
};

export default connect((state) => ({
  paymentMethods: state.purchase.paymentMethods,
  coupon: state.purchase.coupon,
}), {
  openModalUpsell,
  setUpsellPlans,
  setUpsellSourceTags,
})(ShowUpPlan);



// WEBPACK FOOTER //
// ./src/components/search/plans_table/HighligthPlans/ShowUpPlan.jsx